import { LocationWithHierarchyTypeCodes } from 'shared/enums';
import { SiteLocation } from 'shared/types';

export const isInvalidArea = (location: SiteLocation, isLocationsHierarchyEnabled: boolean): boolean => {
  const isArea = [
    LocationWithHierarchyTypeCodes.DOCKAREA,
    LocationWithHierarchyTypeCodes.PARKINGAREA,
    LocationWithHierarchyTypeCodes.SCALE,
  ].includes(location.locationTypeCode!);

  // An area can have trailers if it has capacity and no children
  const canHaveTrailers = !!location.capacity && (location.childrenIds?.length ?? 0) === 0;

  // Return true (invalid) only if it's an area that cannot have trailers
  return isLocationsHierarchyEnabled ? isArea && !canHaveTrailers : false;
};
